import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@cuorum/ui/fonts.css';
import '@cuorum/ui/styles.css';
import './app/app.css';
import { App } from './app/App.tsx';
import { createApi } from './lib/api.ts';
import { createAiApi } from './lib/aiApi.ts';
import { DEMO_ACCOUNT } from './features/create/draft.ts';

const root = document.getElementById('root');
if (!root) throw new Error('falta #root en index.html');

createRoot(root).render(
  <StrictMode>
    <App api={createApi(import.meta.env.VITE_API_URL)} ai={createAiApi(import.meta.env.VITE_API_URL, DEMO_ACCOUNT.id)} />
  </StrictMode>,
);
